import {
  useTheme,
  WBBox,
  WBDialog,
  WBDialogContent,
  WBFlex,
  WBIcon,
  WBIconButton,
  WBLink,
  WBSvgIcon,
  WBTypography,
} from '@admiin-com/ds-web';
import LinkIcon from '../../../assets/icons/link.svg';
import { useClipboard } from '@admiin-com/ds-hooks';
import { useSnackbar } from '@admiin-com/ds-web';
import { useTranslation } from 'react-i18next';
import { CurrencyNumber } from '../CurrencyNumber/CurrencyNumber';
import { DialogTitle } from '@mui/material';
import React from 'react';

export interface BpayDetailsDialogProps {
  open: boolean;
  isTax: boolean;
  onClose: () => void;
  reference?: string | null;
  amount?: number | null;
}

export function BpayDetailsDialog({
  open,
  onClose,
  reference,
  amount,
}: BpayDetailsDialogProps) {
  const { t } = useTranslation();
  const [, copy] = useClipboard();
  const showSnackbar = useSnackbar();
  const theme = useTheme();

  const onCopy = (text: string) => {
    copy(text);
    showSnackbar({
      message: t('copied', { ns: 'settings' }),
      severity: 'success',
      horizontal: 'right',
      vertical: 'bottom',
    });
  };

  return (
    <WBDialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle variant="h3" fontWeight={'bold'} color="text.primary" p={0}>
        {t('bpayDetails', { ns: 'contacts' })}
      </DialogTitle>
      <WBIconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: {
            xs: 0,
            sm: 0,
          },
          top: 0,
          color: (theme) => theme.palette.grey[500],
          zIndex: 1200,
        }}
      >
        <WBIcon name="Close" />
      </WBIconButton>
      <WBDialogContent>
        <WBBox>
          <WBTypography variant="h5">
            {t('billerName', { ns: 'contacts' })}
          </WBTypography>
          <WBTypography mr={1}>Australian Tax Office</WBTypography>
          <WBTypography variant="h5" mt={3}>
            {t('bpayBillerCode', { ns: 'contacts' })}
          </WBTypography>
          <WBFlex alignItems="center">
            <WBTypography mr={1}>75556</WBTypography>
            <WBIconButton onClick={() => onCopy('75556')}>
              <WBSvgIcon fontSize="small" color={theme.palette.primary.main}>
                <LinkIcon />
              </WBSvgIcon>
            </WBIconButton>
          </WBFlex>
          <WBTypography variant="h5" mt={3}>
            {t('bpayReferenceNumber', { ns: 'taskbox' })}
          </WBTypography>
          <WBFlex alignItems="center">
            <WBTypography mr={1}>{reference ?? ''}</WBTypography>
            {reference && (
              <WBIconButton onClick={() => onCopy(reference)}>
                <WBSvgIcon fontSize="small" color={theme.palette.primary.main}>
                  <LinkIcon />
                </WBSvgIcon>
              </WBIconButton>
            )}
          </WBFlex>
          <WBTypography variant="h5" mt={3}>
            {t('amount', { ns: 'common' })}
          </WBTypography>
          <WBFlex alignItems="center">
            <CurrencyNumber number={(amount ?? 0) / 100} sup={false} />
          </WBFlex>
        </WBBox>
        <>
          <WBFlex py={1} justifyContent="center" alignItems="center">
            <WBBox height="1px" width="100%" backgroundColor="#e8eaed" />
            <WBBox whiteSpace="nowrap">
              <WBTypography color="#68707a" paddingX={1}>
                {t('or', { ns: 'common' })}
              </WBTypography>
            </WBBox>

            <WBBox height="1px" width="100%" backgroundColor="#e8eaed" />
          </WBFlex>
          <WBFlex alignItems="center" justifyContent="center">
            <WBTypography variant="body2" color="grey">
              <WBLink
                variant="body2"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  onClose();
                }}
              >
                {t('payTitle', { ns: 'common' })}
              </WBLink>{' '}
              {t('payWithCardPoints', { ns: 'common' })}
            </WBTypography>
          </WBFlex>
        </>
      </WBDialogContent>
    </WBDialog>
  );
}

export default BpayDetailsDialog;
